<template>
  <div>
    <v-menu v-model="current.checkOpened" :close-on-content-click="false" max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn text small v-on="on">
          <v-icon left>mdi-calendar-clock</v-icon>
          <span>{{ $moment(current.check.created_at).format('ll') }}</span>
        </v-btn>
      </template>
      <v-list class="overflow-y-auto" max-height="400">
        <v-list-item
          @click="changeCurrentCheck(check)"
          v-for="check in similarChecks"
          :key="check.id">
          <v-list-item-title>{{ $moment(check.created_at).format('lll') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu v-model="current.datacenterOpened" :close-on-content-click="false" max-width="200px" min-width="200px">
      <template v-slot:activator="{ on }">
        <v-btn text small v-on="on" :disabled="reports.find('current').length === 0">
          <v-icon left>mdi-podium-gold</v-icon>
          <span>{{ currentReportSelectedPosition }}</span>
        </v-btn>
      </template>
      <v-list v-if="reports.find('current').length > 0">
        <v-list-item
          @click="changeCurrentDatacenter(datacenter)"
          v-for="{datacenter, position} in reports.find('current')"
          :key="datacenter">
          <v-list-item-title>
            <v-chip :color="getColor(position)" dark small>{{ position }}</v-chip>
            <span class="grey--text float-right" style="font-size: 0.8em; margin-top: 4px;">{{ datacenter }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    {{ $t('compared-to') }}
    <v-menu v-model="comparison.checkOpened" :close-on-content-click="false" max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn text small v-on="on">
          <v-icon left>mdi-calendar-clock</v-icon>
          <span v-if="comparison.check">{{ $moment(comparison.check.created_at).format('ll') }}</span>
          <span v-else>{{ $t('choose-date') }}</span>
        </v-btn>
      </template>
      <v-list class="overflow-y-auto" max-height="400">
        <v-list-item
          @click="changeComparisonCheck(check)"
          v-for="check in similarChecks"
          :key="check.id">
          <v-list-item-title>{{ $moment(check.created_at).format('lll') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu v-model="comparison.datacenterOpened" :close-on-content-click="false" max-width="200px" min-width="200px">
      <template v-slot:activator="{ on }">
        <v-btn text small v-on="on" :disabled="reports.find('comparison').length === 0">
          <v-icon left>mdi-podium-gold</v-icon>
          <span>{{ comparisonReportSelectedPosition }}</span>
        </v-btn>
      </template>
      <v-list v-if="reports.find('comparison').length > 0">
        <v-list-item
          @click="changeComparisonDatacenter(datacenter)"
          v-for="{datacenter, position} in reports.find('comparison')"
          :key="datacenter">
          <v-list-item-title>
            <v-chip :color="getColor(position)" dark small>{{ position }}</v-chip>
            <span class="grey--text float-right" style="font-size: 0.8em; margin-top: 4px;">{{ datacenter }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'CheckPicker',
  props: [
    'currentCheck',
    'currentCheckDatacenter',
    'comparisonCheck',
    'comparisonCheckDatacenter',
    'similarChecks'
  ],
  data () {
    return {
      current: {
        check: this.currentCheck,
        datacenter: this.currentCheckDatacenter,
        checkOpened: false,
        datacenterOpened: false
      },
      comparison: {
        check: null,
        datacenter: null,
        checkOpened: false,
        datacenterOpened: false
      },
      reports: null
    }
  },
  watch: {
    'current.check' () { this.emitChanged() },
    'current.datacenter' () { this.emitChanged() },
    'comparison.check' () { this.emitChanged() },
    'comparison.datacenter' () { this.emitChanged() },
  },
  computed: {
    currentReportSelectedPosition () {
      if (!this.current.datacenter) return null
      const found = this.reports.find('current').find(({ datacenter }) => datacenter === this.current.datacenter)
      if (found) return found.position
      else return null
    },
    comparisonReportSelectedPosition () {
      if (!this.comparison.datacenter) return null
      const found = this.reports.find('comparison').find(({ datacenter }) => datacenter === this.comparison.datacenter)
      if (found) return found.position
      else return null
    }
  },
  methods: {
    emitChanged () {
      this.$emit('changed', {
        current: this.current,
        comparison: this.comparison
      })
    },
    getColor (value) {
      value = parseInt(value)
      if (value === 0) return 'error'
      if (value === 1) return 'success'
      if (value === 2) return 'light-green'
      if (value === 3) return 'lime'
      if (value < 10) return 'orange'
      else return 'error'
    },
    async fetchReports () {
      this.reports.sync({
        current: this.current.check ? this.$models.CarrierObjects.checkReport(this.current.check) : undefined,
        comparison: this.comparison.check ? this.$models.CarrierObjects.checkReport(this.comparison.check) : undefined
      })
    },
    async changeCurrentCheck (check) {
      this.progress = true
      const report = await this.reports.add({ current: this.$models.CarrierObjects.checkReport(check) })
      this.current.check = check
      this.current.datacenter = report[0].datacenter
      this.current.checkOpened = false
      this.progress = false
      return await this.fetchReports()
    },
    async changeComparisonCheck (check) {
      this.progress = true
      const report = await this.reports.add({ comparison: this.$models.CarrierObjects.checkReport(check) })
      this.comparison.check = check
      this.comparison.datacenter = report[0].datacenter
      this.comparison.checkOpened = false
      this.progress = false
      return await this.fetchReports()
    },
    changeCurrentDatacenter (datacenter) {
      this.current.datacenter = datacenter
      this.current.datacenterOpened = false
    },
    changeComparisonDatacenter (datacenter) {
      this.comparison.datacenter = datacenter
      this.comparison.datacenterOpened = false
    }
  },
  created () {
    this.reports = this.$carrier.collection({
      missing: {},
      present: data => {
        return Object.keys(data).map(datacenter => {
          const position = data[datacenter]
          if (position === false) return false
          else return { datacenter, position }
        }).filter(entry => entry !== false)
      }
    }, this)
  },
  mounted () {
    this.fetchReports()
  },
  destroyed () {
    this.reports.destroy()
  },
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"choose-date": "Select a date",
		"compared-to": "Compared To"
	},
	"es": {
		"choose-date": "Seleccionar una fecha",
		"compared-to": "en comparación con"
	},
	"fr": {
		"choose-date": "Sélectionnez une date",
		"compared-to": "comparé à"
	},
	"it": {
		"choose-date": "Seleziona una data",
		"compared-to": "confrontato con"
	},
	"pt": {
		"choose-date": "Selecionar uma data",
		"compared-to": "comparado com"
	},
	"pl": {
		"choose-date": "Wybierz datę",
		"compared-to": "w porównaniu z"
	}
}
</i18n>